module.exports = {"reportYear":2026,"esgReportYear":2020}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = QkNq
// module chunks = 3